import { FC } from 'react'
import numeralImage from './numeralCover.png'
import {
  Text,
  GreyGrey30,
  GreyGrey90,
  Image,
  ListItem,
  Primary13Regular,
  UnorderedList,
  Box,
  Flex
} from '@sequencehq/core-components'

export const NumeralIntegrationDetail: FC = () => {
  return (
    <Flex flexDirection="column" gap="20px">
      <Image
        src={numeralImage}
        width="100%"
        aspectRatio={1288 / 512}
        borderRadius="8px"
        border={`1px solid ${GreyGrey30}`}
        draggable={false}
      />
      <Text {...Primary13Regular} color={GreyGrey90}>
        Numeral is a comprehensive tax compliance platform that automates sales
        tax calculations, filing, and reporting across multiple jurisdictions.
        Integrate with Numeral to streamline your tax processes and ensure
        regulatory compliance. This connector requires an account with Numeral.
      </Text>
      <Box {...Primary13Regular} color={GreyGrey90} lineHeight="18px">
        <UnorderedList>
          <ListItem>
            <strong>Automated tax calculations:</strong> Calculate precise tax
            rates based on customer addresses and product categories
          </ListItem>
          <ListItem>
            <strong>Tax return filing:</strong> Automatically handle tax return
            filing after sales clear through the platform
          </ListItem>
          <ListItem>
            <strong>Product management:</strong> Manage product tax categories
            and handle refunds seamlessly
          </ListItem>
          <ListItem>
            <strong>Exempt customer handling:</strong> Efficiently manage
            tax-exempt customers across multiple jurisdictions
          </ListItem>
        </UnorderedList>
      </Box>
    </Flex>
  )
}
